import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/common';
import { LuCalendarClock, LuPlus, LuStickyNote } from 'react-icons/lu';

/** Shown when the activity feed has no rows for the current filter. */
export const ActivityEmptyState = ({ onCreateActivity, onCreateTask, filtered }) => (
  <div className="tw-p-10 tw-text-center">
    <div className="tw-w-14 tw-h-14 tw-rounded-2xl tw-bg-white tw-ring-1 tw-ring-slate-200 tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-4">
      <LuCalendarClock size={26} className="tw-text-slate-400" />
    </div>
    <h6 className="tw-text-sm tw-font-bold tw-text-slate-700 tw-mb-1">
      {filtered ? 'Nothing of this type yet' : 'No activities yet'}
    </h6>
    <p className="tw-text-xs tw-text-slate-400 tw-mb-5 tw-max-w-xs tw-mx-auto tw-leading-relaxed">
      {filtered
        ? 'Try another type, or log something new for this deal.'
        : 'Log a customer interaction or create a task to keep this deal moving forward.'}
    </p>
    <div className="tw-flex tw-justify-center tw-gap-2 tw-flex-wrap">
      <Button variant="primary" size="md" leftIcon={LuPlus} onClick={onCreateActivity}>
        Customer interaction
      </Button>
      <Button variant="secondary" size="md" leftIcon={LuPlus} onClick={onCreateTask}>
        Task
      </Button>
    </div>
  </div>
);

ActivityEmptyState.propTypes = {
  onCreateActivity: PropTypes.func.isRequired,
  onCreateTask:     PropTypes.func.isRequired,
  /** A type filter is active, so the feed may be empty only for that type. */
  filtered:         PropTypes.bool,
};

ActivityEmptyState.defaultProps = { filtered: false };

/** Shown when the Notes column is empty. */
export const NoteEmptyState = ({ onCreate }) => (
  <div className="tw-rounded-2xl tw-border tw-border-dashed tw-border-amber-300 tw-bg-amber-50/40 tw-p-6 tw-text-center">
    <div className="tw-w-11 tw-h-11 tw-rounded-xl tw-bg-white tw-ring-1 tw-ring-amber-200 tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-3">
      <LuStickyNote size={18} className="tw-text-amber-500" />
    </div>
    <p className="tw-text-xs tw-font-bold tw-text-slate-700 tw-mb-1">No notes yet</p>
    <p className="tw-text-[11px] tw-text-slate-400 tw-mb-3 tw-leading-relaxed">
      Rich text, images and tables supported.
    </p>
    <Button variant="warning" size="sm" leftIcon={LuPlus} onClick={onCreate}>
      Write a note
    </Button>
  </div>
);

NoteEmptyState.propTypes = {
  onCreate: PropTypes.func.isRequired,
};
